export default __webpack_public_path__ + "static/10-2b8162612f73c0f5ed6575cbed094006.webp";